<template>
  <div>
    <div class="row m-t-sm">
      <v-select :options="orders" placeholder="Order Type"></v-select>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      orders: [
        {
          'index': 'maintenance',
          'label': 'Maintenance'
        }
      ]
    }
  },
  props: ['items']
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Lists/ModalActions/CreateOrder.vue